
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inventory-system",
      function () {
        return require("private-next-pages/inventory-system.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inventory-system"])
      });
    }
  